import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng2-click-outside';
import { AccordionModule } from 'ng2-bootstrap/components/accordion';
import { DropdownModule } from 'ng2-bootstrap/components/dropdown';
import { SlimScrollModule } from 'ng2-slimscroll';
import { ModalModule } from 'ng2-bootstrap/ng2-bootstrap';

import { SharedPopupComponent } from './shared-popup/shared-popup.component';
import { MemberTableComponent } from './member-table/member-table.component';
import { GroupPipe } from './group.search'
import { MemberPipe } from './search.member';
import { ScheduleModule, CalendarModule, TooltipModule } from 'primeng/primeng';
import { DeactivatePopupComponent } from './deactivate-popup/deactivate-popup.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ClickOutsideModule,
        AccordionModule,
        DropdownModule,
        ModalModule,
        ScheduleModule,
        CalendarModule,
        TooltipModule,
        SlimScrollModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ClickOutsideModule,
        AccordionModule,
        DropdownModule,
        ModalModule,
        SharedPopupComponent,
        MemberTableComponent,
        GroupPipe,
        MemberPipe,
        DeactivatePopupComponent,
        ScheduleModule,
        CalendarModule,
        TooltipModule
    ],
    declarations: [SharedPopupComponent, MemberTableComponent, GroupPipe, MemberPipe, DeactivatePopupComponent]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts